<h1>Welcome</h1>
<p>This is Angular framework Practice</p>
<button class="btn btn-info m-1" routerLink="/users">Users Section</button>
<button class="btn btn-primary" routerLink="/posts">Posts Section</button>
